import React, { useEffect } from "react";
import { TestType } from "../models/Enums";
import {
  FiveXTSScore,
  GaitScore,
  Score,
  UpperBodyAromScore,
  RLGLScore,
  AFScore,
  BalloonPopperScore,
  VeggieSlicerScore,
  TugScore,
  FunctionalReachScore,
  MctsibScore,
} from "../models/reports";
import FiveXSitStandTest from "./tests/Five_X_Sit_Stand_Test";
import GaitTest from "./tests/Gait_Test";
import UpperBodyAromTest from "./tests/Upper_Body_Arom_Test";
import RLGLTest from "./tests/RLGL_Test";
import AFTest from "./tests/AF_Test";
import BalloonPopperTest from "./tests/BallonPopper_Test";
import VeggieSlicerTest from "./tests/VeggieSlicer_Test";
import TugTest from "./tests/Tug_Test";
import FunctionalReachTest from "./tests/FunctionalReach_Test";
import MctsibTest from "./tests/Mctsib_Test";

interface Props {
  score: Score;
  testType: Number;
}
const TestWrapper: React.FC<Props> = ({ score, testType }) => {
  useEffect(() => {
    console.log("score", score);
    console.log("testType", testType);
  }, [score, testType]);
  return (
    <>
      {testType === TestType.gait && <GaitTest score={score as GaitScore} />}
      {testType === TestType.five_x_sit_stand && (
        <FiveXSitStandTest score={score as FiveXTSScore} />
      )}
      {testType === TestType.upper_body_arom && (
        <UpperBodyAromTest score={score as UpperBodyAromScore} />
      )}
      {testType === TestType.red_light_green_light && (
        <RLGLTest score={score as RLGLScore} />
      )}
      {testType === TestType.game_AF && <AFTest score={score as AFScore} />}
      {testType === TestType.hec_training && (
        <BalloonPopperTest score={score as BalloonPopperScore} />
      )}
      {testType === TestType.veggie_samurai && (
        <VeggieSlicerTest score={score as VeggieSlicerScore} />
      )}
      {testType === TestType.tug && <TugTest score={score as TugScore} />}
      {testType === TestType.reach && (
        <FunctionalReachTest score={score as FunctionalReachScore} />
      )}
      {testType === TestType.ctsib && (
        <MctsibTest score={score as MctsibScore} />
      )}
    </>
  );
};

export default TestWrapper;
